import { Box, Grid, Paper, useTheme } from "@mui/material";
import { gridClasses, GridColDef } from "@mui/x-data-grid";
import { FC, useMemo } from "react";
import { Link, Outlet } from "react-router-dom";
import { Permissions, Precinct } from "../../api/dtos";
import GridActions from "../../components/GridActions";
import SetLinks from "../../components/layout/SetLinks";
import { StyledButton } from "../../components/StyledButton";
import CollapsibleTablePremium from "../../components/tables/CollapsibleTablePremium";
import { createCustomToolbarProps } from "../../components/utility/CustomToolbarProps";
import { DefaultProjectCreateLink } from "../../contexts/layouts/LinkContext";
import PrecinctsContext from "../../contexts/PrecinctsContext";
import usePrecincts from "../../hooks/data/usePrecincts";

const usePrecinctColumns = () => {

    const agentColumns = useMemo(() => {
        const columns: GridColDef<Precinct>[] =  [
            {
                field: "name",
                headerName: "Name",
                flex: 1
            },
            {
                field: "rank",
                headerName: "Rank",
                flex: 1
            },
            {
                field: "actions",
                headerName: '',
                renderCell: (params) => {
                    return (
                        <GridActions
                            editPermission={Permissions.AdminAccess}
                            editUrl={`/admin/stage-precincts/edit/${params.row.id}`}
                        />
                    )
                },
                disableExport: true
            }
        ];

        return columns;
    }, []);

    return agentColumns;
}


const Precincts:FC = () => {

    const columns = usePrecinctColumns();

    const theme = useTheme();
    
    const context = usePrecincts();

    const {data: precincts, loading: precinctsLoading} = context;

    const customToolbarProps = useMemo(() => createCustomToolbarProps({
        fileName: `Stage Precincts`,
        exportTitle: `Stage Precincts`,
        includeDateTime: true
    }), []);

    return (
        <PrecinctsContext.Provider value={context}>
            <Outlet />
            <SetLinks
                createProjectLink={DefaultProjectCreateLink}
                stageLinkEnabled={false}
                lotLinkEnabled={false}
            />
            <Grid
                container
                gap={theme.spacing(2)}
                justifyContent={"end"}
                marginBottom={theme.spacing(2)}
            >
                <StyledButton 
                        variant="contained"
                        //@ts-expect-error
                        component={Link}
                        to={`/admin/stage-precincts/create`}
                        state={{
                            back: true
                        }}
                >
                    Add Precinct
                </StyledButton>
            </Grid>
            <Paper>
                <Box
                    sx={{
                        [`& .${gridClasses.root}`]: {
                            
                            [`& .${gridClasses.columnHeader}`]: {
                                height: 'auto !important',
                                minHeight: 56,
                                
                                [`& .${gridClasses.columnHeaderTitleContainer}`]: {
                                    whiteSpace: 'normal',
                                    
                                    [`& .${gridClasses.columnHeaderTitle}`]: {
                                        whiteSpace: 'normal',
                                        paddingTop: theme.spacing(1.5),
                                        paddingBottom: theme.spacing(1.5) 
                                    }
                                },
                                
                                [`& .${gridClasses.iconButtonContainer}`]: {
                                    width: 'unset',
                                },
                                
                                '&.column-group-header': {
                                    backgroundColor: theme.palette.grey[300],
                                    boxShadow: "1",
                                    textAlign: 'center'
                                }
                            }
                        },
                    }}
                    >
                    <CollapsibleTablePremium
                        density="compact"
                        startCollapsed={false} 
                        title={"Precincts"} 
                        loading={precinctsLoading} 
                        columns={columns}
                        rows={precincts}
                        disableColumnMenu={false}
                        disableColumnFilter={false}
                        {...customToolbarProps}
                    />
                </Box>
            </Paper>
        </PrecinctsContext.Provider>
    );
}

export default Precincts;